module.exports = __webpack_public_path__ + "static/media/pin.934f363d.svg";